module.exports = __webpack_public_path__ + "img/is.c100cc1e.svg";